export class SearchResponse<T>
{
    hasMore: boolean = true;
    results?: T[];
}